import { render, staticRenderFns } from "./parallaxScrolling.vue?vue&type=template&id=18d6f75e&"
import script from "./parallaxScrolling.vue?vue&type=script&lang=js&"
export * from "./parallaxScrolling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports